<template>
    <div class="main">
        <div class="grid-container">
            <div class="grid-x">
                <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">
                    <div v-if="sneaker != null" class="card">
                        <img :src="sneaker.image_url" />
                        <div class="card-section">
                            <p class="lead">{{ sneaker.brand }}</p>
                            <p>{{ sneaker.model_name }}</p>
                            <div class="grid-x card-info">
                                <div class="small-5 small-offset-1">
                                    <p>{{ sneaker.release_date_pretty }}</p>
                                </div>
                                <div class="small-5 small-offset-1">
                                    <p>{{ sneaker.original_price | price }}</p>
                                </div>
                            </div>
                            <div v-if="user">
                                <button v-on:click="addSneakerToWishlist()" class="button">Add to wishlist</button>
                                <button v-on:click="removeSneakerFromWishlist()" class="button alert">Remove from wishlist</button>
                            </div>
                            <div v-if="user"> 
                                <button v-on:click="addSneakerToCollection()" class="button">Add to collection</button>
                                <button v-on:click="removeSneakerFromCollection()" class="button alert">Remove from collection</button>
                            </div>
                            <div v-else>
                                <p>Please 
                                    <router-link to="/login">log in</router-link> or
                                    <router-link to="/signup">sign up</router-link> to add to wishlist or collection.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'
export default {
    name: 'sneaker',
    props: ['slug'],
    data () {
        return {
        }
    },
    computed: {
        sneaker () {
            return this.$store.getters.loadedSneaker(this.slug)
        },
        user () {
            return this.$store.getters.user
        }
    },
    methods: {
        addSneakerToWishlist: function () {
            this.$store.dispatch('addSneakerToWishlist', this.sneaker)
        },
        removeSneakerFromWishlist: function () {
            this.$store.dispatch('removeSneakerFromWishlist', this.sneaker)
        },
        addSneakerToCollection: function () {
            this.$store.dispatch('addSneakerToCollection', this.sneaker)
        },
        removeSneakerFromCollection: function () {
            this.$store.dispatch('removeSneakerFromCollection', this.sneaker)
        }
    },
    filters: {
        price: function (value) {
            return Number.isInteger(value) ? "€" + value : value
        }
    }
}
</script>
<style scoped>
.card img {
    height: 28vh;
}
</style>



// WEBPACK FOOTER //
// Sneaker.vue?1586d350